import React, { useEffect, useState } from 'react';
import axios from 'axios';
import '../styles/menuStockManager.css';
import { initialMenuItems } from '../pages/Bestellen';
import { getApiBaseUrl } from '../utils/apiConfig';


const MenuStockManager = () => {
    const [stockStatus, setStockStatus] = useState({});
    const API_BASE = getApiBaseUrl();


    // Fetch initial stock status
    useEffect(() => {
        const fetchStockStatus = async () => {
            try {
                const response = await axios.get(`${API_BASE}/api/menu/stock`);
                const statusMap = response.data.reduce((acc, item) => {
                    acc[item.id] = item.inStock;
                    return acc;
                }, {});
                setStockStatus(statusMap);
            } catch (err) {
                console.error('Error fetching stock status:', err);
            }
        };
        fetchStockStatus();
    }, [API_BASE]);

    // Toggle stock status
    const toggleStockStatus = async (itemId) => {
        try {
            const currentStatus = stockStatus[itemId] !== false; // Handle undefined as true
            const newStatus = !currentStatus;

            // Optimistic update
            setStockStatus(prev => ({
                ...prev,
                [itemId]: newStatus
            }));

            // inside toggleStockStatus
            await axios.put(`${API_BASE}/api/menu/${itemId}/stock`, {
                inStock: newStatus
            });

        } catch (err) {
            console.error('Update failed:', err);
            // Revert on error
            setStockStatus(prev => ({
                ...prev,
                [itemId]: !prev[itemId]
            }));
        }
    };

    return (
        <div className="menu-stock-manager">
            <h2>Menu Availability Management</h2>
            <table>
                <thead>
                    <tr>
                        <th>Image</th>
                        <th>Title</th>
                        <th>Category</th>
                        <th>Status</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {initialMenuItems.map(item => {
                        const isInStock = stockStatus[item.id] !== false; // Default to true
                        return (
                            <tr key={item.id}>
                                <td><img src={item.image} alt={item.title} width="50" /></td>
                                <td>{item.title}</td>
                                <td>{item.category}</td>
                                <td style={{ color: isInStock ? 'green' : 'red' }}>
                                    {isInStock ? 'In Stock' : 'Out of Stock'}
                                </td>
                                <td>
                                    <button
                                        onClick={() => toggleStockStatus(item.id)}
                                        className={isInStock ? 'in-stock' : 'out-of-stock'}
                                    >
                                        {isInStock ? 'Mark Out of Stock' : 'Mark In Stock'}
                                    </button>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};

export default MenuStockManager;